export const CHANGE_STATE = 'CHANGE_STATE'
export const BLANK_NCCD = 'BLANK_NCCD'
export const RESET_NCCD = 'RESET_NCCD'
export const NEW_TO_OLD = 'NEW_TO_OLD'